import { Card, CardContent } from "@/components/ui/card";
import { HeartPulse, Smartphone, Users, Activity, Cpu } from "lucide-react";

const technologies = [
  {
    icon: Users,
    title: "Seamless health monitoring during daily activities",
    description: "Track vital signs accurately during any activity, from workouts to daily tasks",
  },  
  {
    icon: Smartphone,
    title: "Professional-grade health insights without additional hardware ",
    description: "Works with existing active-noise cancelling earbuds through our sophisticated API",
  },
  {
    icon: Cpu,
    title: "Cutting-edge AI algorithms",
    description: "Built on advanced audio-based foundation models for superior accuracy and reliability",
  },
];

export const TechSection = () => {
  return (
    <section id="tech" className="min-h-screen py-20 px-4 bg-white pattern-overlay">
      <div className="max-w-6xl mx-auto">
        <h2 className="text-3xl font-bold text-center mb-6 text-foreground">
          You wear your earbuds. We monitor your health.
        </h2>
        <p className="text-center text-lg mb-12 max-w-3xl mx-auto text-muted-foreground">
          We redefine wearable technology by turning everyday earbuds into health monitoring devices. We use advanced AI algorithms and the built-in microphones of earbuds to monitor vital signs with unprecedented accuracy.
        </p>
        
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {technologies.map((tech) => (
            <Card 
              key={tech.title} 
              className="fade-in transition-all duration-300 hover:shadow-xl hover:-translate-y-1 bg-white border border-border hover:border-[#ffa05d]/50 h-full"
            >
              <CardContent className="p-8 flex flex-col h-full">
                <div className="mb-6 flex justify-center">
                  <div className="p-4 rounded-full bg-[#A4CBA6] flex items-center justify-center">
                    <tech.icon size={32} className="text-foreground" />
                  </div>
                </div>
                <h3 className="text-xl font-semibold text-center mb-4 text-foreground">{tech.title}</h3>
                <p className="text-center text-muted-foreground flex-grow">{tech.description}</p>
              </CardContent>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
};
